export const OPEN_SHOP_THE_LOOK_DIALOG = 'OPEN_SHOP_THE_LOOK_DIALOG'
export const CLOSE_SHOP_THE_LOOK_DIALOG = 'CLOSE_SHOP_THE_LOOK_DIALOG'

export const FETCH_SHOP_THE_LOOK_PRODUCTS_ERROR = 'FETCH_SHOP_THE_LOOK_PRODUCTS_ERROR'
export const FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS = 'FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS'


export const openShopTheLookDialog = (id, title, items) => {
    return {type: OPEN_SHOP_THE_LOOK_DIALOG, payload: {id, title, items}}
}

export const closeShopTheLookDialog = () => {
    return {type: CLOSE_SHOP_THE_LOOK_DIALOG}
}


// WEBPACK FOOTER //
// ./src/actions/shopTheLook.js